import { commonTranslationKeys } from '@dreryk/react-common';
import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

import { MedicalDocumentationDownloadAction } from './actions/MedicalDocumentationDownloadAction';
import { MedicalDocumentationCreateForm } from './MedicalDocumentationCreateForm';
import { MedicalDocumentationSendAndShareShowModalEventInterceptor } from './actions/interceptors/MedicalDocumentationSendAndShareShowModalEventInterceptor';
import { MedicalDocumentationDownloadUnencryptedAction } from './actions/MedicalDocumentationDownloadUnencryptedAction';
import { MedicalDocumentationDownloadEncryptedAction } from './actions/MedicalDocumentationDownloadEncryptedAction';

type MedicalDocumentationCreateModalProps = Readonly<{
   patientId: number;
   onCancel: VoidFunction;
   onCreate: VoidFunction;
}>;

// eslint-disable-next-line max-lines-per-function
export const MedicalDocumentationCreateModal = (props: MedicalDocumentationCreateModalProps): JSX.Element => {
   return (
      <Modal
         title={medicalDocumentationCreateTranslationKeys.createPatientRecordsModal.title}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'medicalDocumentationCreate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <MedicalDocumentationCreateForm>
            {({ formState, trigger, handleSubmit }) => (
               <>
                  <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />

                  {protectFeature(
                     'sendingDocumentsToPatient',
                     <>
                        <MedicalDocumentationDownloadAction
                           handleSubmit={handleSubmit}
                           onCreate={props.onCreate}
                           patientId={props.patientId}
                           trigger={trigger}
                        />

                        <ValidateFormEventInterceptor trigger={trigger}>
                           <MedicalDocumentationSendAndShareShowModalEventInterceptor
                              patientId={props.patientId}
                              handleSubmit={handleSubmit}
                           >
                              <ModalConfirmButton
                                 label={
                                    medicalDocumentationCreateTranslationKeys.createPatientRecordsModal
                                       .medicalDocumentationShareButtonLabel
                                 }
                                 onClick={props.onCreate}
                              />
                           </MedicalDocumentationSendAndShareShowModalEventInterceptor>
                        </ValidateFormEventInterceptor>
                     </>,
                     <>
                        <MedicalDocumentationDownloadUnencryptedAction
                           handleSubmit={handleSubmit}
                           onCreate={props.onCreate}
                           patientId={props.patientId}
                        />

                        <MedicalDocumentationDownloadEncryptedAction
                           handleSubmit={handleSubmit}
                           onCreate={props.onCreate}
                           patientId={props.patientId}
                        />
                     </>
                  )}
               </>
            )}
         </MedicalDocumentationCreateForm>
      </Modal>
   );
};
